export default function Loader() {
  return (
    <div className="flex justify-center items-center py-4">
      <div className="w-16 h-16 border-4 border-t-4 border-gray-300 rounded-full animate-spin border-t-blue-500"></div>
    </div>
  );
}
